import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { updateParkStatus, fetchInvoiceItems } from "../Api/VendorInvoice";
import { Base_URL, Base_URL2 } from "../url";

import "../Styling/PayrollTheme.css";
import "../Styling/VIMTheme.css";

const formatCurrency = (value) => {
  if (value === null || value === undefined) return "—";

  return Number(value).toLocaleString("en-IN", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

const formatSAPDate = (date) => {
  if (!date) return "—";
  const d = new Date(date);

  return (
    d.getFullYear() +
    String(d.getMonth() + 1).padStart(2, "0") +
    String(d.getDate()).padStart(2, "0")
  );
};

const VIMInvoiceGrid = ({ data = [], reloadInvoices }) => {
  const navigate = useNavigate();

  const [rows, setRows] = useState([]);

  useEffect(() => {
    setRows(data);
  }, [data]);

  const handleParkStatus = async (guid, type) => {
    try {
      const payload = {
        invoice_Staging_Guid: guid,
        parkStatus: type,
      };

      await updateParkStatus(payload);

      setRows((prev) =>
        prev.map((item) =>
          item.Invoice_Staging_Guid === guid
            ? {
                ...item,
                parkStatus: type,
              }
            : item,
        ),
      );
    } catch (err) {
      console.error("Status update failed", err);
    }
  };

  const handleParkAction = async (row, type) => {
    try {
      await handleParkStatus(row.Invoice_Staging_Guid, type);

      const invoiceItems = await fetchInvoiceItems(row.Invoice_Staging_Guid);

      const sapPayload = {
        INVOICE_STAGING_GUID: row.Invoice_Staging_Guid,

        VENDORNAME: row.VendorName,
        VENDORADDRESS: row.VendorAddress,
        VENDORTAXID: row.VendorTaxId,

        CUSTOMERNAME: row.CustomerName,
        CUSTOMERADDRESS: row.CustomerAddress,
        CUSTOMERTAXID: row.CustomerTaxId,

        INVOICENUMBER: row.InvoiceNumber,

        INVOICEDATE: formatSAPDate(row.InvoiceDate),
        DUEDATE: formatSAPDate(row.DueDate),

        PAYMENTTERM: row.PaymentTerm,
        PURCHASEORDER: row.PurchaseOrder,

        SUBTOTAL: String(row.BaseAmount),
        TOTALTAX: String(row.TotalTax || 0),
        INVOICETOTAL: String(row.InvoiceTotal || 0),

        CURRENCYCODE: row.CurrencyCode,

        CGSTRATE: String(row.CGSTRate || 0),
        CGSTAMOUNT: String(row.CGSTAmount || 0),

        SGSTRATE: String(row.SGSTRate || 0),
        SGSTAMOUNT: String(row.SGSTAmount || 0),

        IGSTRATE: String(row.IGSTRate || 0),
        IGSTAMOUNT: String(row.IGSTAmount || 0),

        PARKSTATUS: type,

        INVC_ITEMSet: invoiceItems.map((item) => ({
          HEADERGUID: row.Invoice_Staging_Guid,

          DESCRIPTION: item.Description,

          HSMCode: item.HSMCode,

          QUANTITY: String(item.Quantity),

          UNITPRICE: String(item.UnitPrice),

          AMOUNT: String(item.Amount),
        })),
      };

      console.log(JSON.stringify(sapPayload, null, 2));
      const response = await fetch(`${Base_URL}/VIM_Masters/send-to-sap`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(sapPayload),
      });

      const result = await response.text();

      console.log(result);
      await reloadInvoices();
    } catch (err) {
      console.error("SAP Send Failed", err);
    }
  };

  const handleDownload = (blobUrl, invoiceNumber) => {
    try {
      if (!blobUrl) {
        alert("Blob URL not found");
        return;
      }

      const link = document.createElement("a");

      link.href = blobUrl;

      link.target = "_blank";

      link.download = `${invoiceNumber || "invoice"}.pdf`;

      document.body.appendChild(link);

      link.click();

      document.body.removeChild(link);
    } catch (err) {
      console.error("Download error:", err);
      alert("Unable to download file");
    }
  };

  return (
    <div className="vim-grid">
      <div className="vim-grid__card">
        <div className="vim-grid__scroll">
          <table className="vim-grid__table">
            <thead>
              <tr>
                <th>Vendor Name</th>
                <th>Vendor Address</th>
                <th>Vendor Tax Id</th>

                <th>Customer Name</th>
                <th>Customer Address</th>
                <th>Customer Tax Id</th>

                <th>Invoice Number</th>
                <th>Invoice Date</th>
                <th>Due Date</th>

                <th>Payment Term</th>
                <th>Purchase Order</th>

                <th>Base Amount</th>
                <th>Total Tax</th>
                <th>Invoice Total</th>

                <th>Currency</th>

                <th>CGST Rate</th>
                <th>CGST Amount</th>

                <th>SGST Rate</th>
                <th>SGST Amount</th>

                <th>IGST Rate</th>
                <th>IGST Amount</th>

                <th>Actions</th>
              </tr>
            </thead>

            <tbody>
              {rows.length === 0 ? (
                <tr>
                  <td colSpan={13} className="vim-grid__empty">
                    No invoices found
                  </td>
                </tr>
              ) : (
                (Array.isArray(rows) ? rows : []).map((row, index) => (
                  <tr key={index}>
                    <td className="vim-grid__vendor">
                      {row.VendorName || "—"}
                    </td>

                    <td>{row.VendorAddress || "—"}</td>

                    <td>{row.VendorTaxId || "—"}</td>

                    <td>{row.CustomerName || "—"}</td>

                    <td>{row.CustomerAddress || "—"}</td>

                    <td>{row.CustomerTaxId || "—"}</td>

                    <td className="vim-link">{row.InvoiceNumber || "—"}</td>

                    <td>
                      {new Date(row.InvoiceDate).toISOString().split("T")[0]}
                    </td>

                    <td>{new Date(row.DueDate).toISOString().split("T")[0]}</td>

                    <td>{row.PaymentTerm || "—"}</td>

                    <td>{row.PurchaseOrder || "—"}</td>

                    <td>{formatCurrency(row.BaseAmount)}</td>

                    <td>{formatCurrency(row.TotalTax)}</td>

                    <td>{formatCurrency(row.InvoiceTotal)}</td>

                    <td>{row.CurrencyCode || "—"}</td>

                    <td>{row.CGSTRate ?? "—"}</td>

                    <td>{formatCurrency(row.CGSTAmount)}</td>

                    <td>{row.SGSTRate ?? "—"}</td>

                    <td>{formatCurrency(row.SGSTAmount)}</td>

                    <td>{row.IGSTRate ?? "—"}</td>

                    <td>{formatCurrency(row.IGSTAmount)}</td>

                    <td>
                      <div className="vim-actions-group">
                        <button
                          className="vim-action__icon"
                          onClick={() =>
                            navigate(`/vim-items/${row.Invoice_Staging_Guid}`)
                          }
                        >
                          ℹ
                        </button>

                        <button
                          className="vim-action__download"
                          onClick={() =>
                            handleDownload(row.BlobUrl, row.InvoiceNumber)
                          }
                          title="Download Invoice"
                        >
                          ⬇
                        </button>
                        <button
  className="vim-action__icon"
  title="Edit Invoice"
  onClick={() => navigate(`/vim-edit/${row.Invoice_Staging_Guid}`)}
>
  ✎
</button>
                       <button
  disabled={!!row.ParkStatus}
  className="vim-action__button"
  onClick={() => handleParkAction(row, "PARKED")}
>
  {row.ParkStatus ? "Parked" : "Park"}
</button>
                      </div>{" "}
                      {/* Existing action buttons */}
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default VIMInvoiceGrid;
